exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-page[data-v-81c02d4a]{padding:20px}", ""]);

// exports
